/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { DatabaseDestination } from '../models/DatabaseDestination';

export class RestoreDbToRdsInstanceRequest {
  /**
  * Eon-assigned ID of the restore account.
  */
  'restoreAccountId': string;
  'destination': DatabaseDestination;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "restoreAccountId",
      "baseName": "restoreAccountId",
      "type": "string",
      "format": "uuid"
    },
    {
      "name": "destination",
      "baseName": "destination",
      "type": "DatabaseDestination",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return RestoreDbToRdsInstanceRequest.attributeTypeMap;
  }

  public constructor() {
  }
}

